import React from 'react';
import { colors, typography, layout, commonStyles } from '../articleMinimalStyles';

const References = ({ references }) => {
  if (!references || references.length === 0) return null;

  const styles = {
    referencesContainer: {
      maxWidth: layout.contentMaxWidth, // Match body width
      margin: '0 auto', // Center
      paddingTop: '30px', // Space above references
    },
    // Reuse commonStyles.sectionTitle if defined appropriately, or define locally:
    title: {
        ...commonStyles.sectionTitle, // Reuse common style
        borderBottom: 'none', // Maybe remove border for last sections
        marginBottom: '20px',
    },
    referenceList: {
      listStyle: 'decimal inside', // Use decimal numbers
      padding: 0,
      margin: 0,
    },
    referenceItem: {
      fontSize: typography.smallSize,
      color: colors.secondaryText,
      lineHeight: 1.6,
      marginBottom: '10px',
      // Style links within references if needed globally or via CSS
    },
  };

  return (
    <section style={styles.referencesContainer} aria-labelledby="references-title">
      <h2 id="references-title" style={styles.title}>References</h2>
      <ol style={styles.referenceList}>
        {references.map((ref) => (
          <li key={ref.id || ref.text} style={styles.referenceItem}>
            {/* Assume ref.text might contain HTML links, use dangerouslySetInnerHTML if needed */}
             {ref.text}
            {/* Or if ref.text is plain:
             <span dangerouslySetInnerHTML={{ __html: ref.text }} />
            */}
          </li>
        ))}
      </ol>
    </section>
  );
};

export default References;